import { AppBar, Badge, Box, Toolbar, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { Notifications } from '@mui/icons-material';
import AvatarMenu from './AvatarMenu/AvatarMenu';
import { CurrentViewContext } from '../../providers/CurrentViewProvider';
import { constants } from '../../constants/constants';
import { SidebarStateContext } from '../../providers/MainProviders';
import { AuthContext } from '../../providers/AuthProvider';

const Header = () => {
  const theme = useTheme();
  const { expanded } = useContext(SidebarStateContext);
  const { view } = useContext(CurrentViewContext);
  const { user, logout } = useContext(AuthContext);

  const headerProps = {
    marginLeft: expanded
      ? constants.components.SIDEBAR_EXPANDED_WIDTH
      : constants.components.SIDEBAR_COLLAPSED_WIDTH,
    width: `calc(100% - ${
      expanded
        ? constants.components.SIDEBAR_EXPANDED_WIDTH
        : constants.components.SIDEBAR_COLLAPSED_WIDTH
    })`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundImage: 'unset',
    display: 'flex',
    boxShadow: 'unset',
  };

  const toolbarProps = {
    minHeight: '64px !important',
    paddingX: '24px !important',
    flexDirection: 'row',
  };

  return (
    <AppBar
      position="sticky"
      sx={headerProps}
    >
      <Toolbar
        variant="regular"
        sx={toolbarProps}
      >
        <Typography variant="h5">{view}</Typography>
        <Box
          sx={{
            display: 'flex',
            ml: 'auto',
          }}
        >
          <Box
            sx={{
              display: 'none',
              alignItems: 'center',
              mr: theme.spacing(1),
            }}
          >
            <Badge
              overlap="circular"
              variant="dot"
              color="warning"
            >
              <Notifications fontSize="small" />
            </Badge>
          </Box>
          <AvatarMenu
            user={user}
            logout={logout}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
